// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import {evaluateEnvFlag} from './utils/featureFlags'

const environment = process.env.REACT_APP_ENVIRONMENT || 'sandbox'
const configs = {
  prod: {
    uaiApi: '',
    ssiApi: '',
    smiApi: '',
    lookerProxyApi: 'https://pmxx5wym2k.execute-api.us-east-1.amazonaws.com/prod/v1.0',
    featureMyProfile: false,
    featrueAuditViewer: false,
    featureUserManagmentProfiles: false,
    featureUserManagmentProfilesEdit: false,
    featureUserManagementProducts: false,
    featureVcascloudDevices: false,
    featureVcascloudContent: false,
    featureVcascloudEntitlements: false,
    showDummyLinks: false,
  },
  uat: {
    uaiApi: 'https://uai-v1.vsaas.eu1.verimatrixuatcloud.net/uai/v1.0/',
    ssiApi: 'https://ssi-v1.vsaas.eu1.verimatrixuatcloud.net/ssi/v1.0/',
    smiApi: 'https://smi-v1.vsaas.eu1.verimatrixuatcloud.net/smi/v1.0/',
    lookerProxyApi: 'https://idgt104mei.execute-api.us-east-1.amazonaws.com/prod/v1.0',
    featureMyProfile: true,
    featrueAuditViewer: true,
    featureUserManagmentProfiles: true,
    featureUserManagmentProfilesEdit: true,
    featureUserManagementProducts: true,
    featureVcascloudDevices: true,
    featureVcascloudContent: true,
    featureVcascloudEntitlements: true,
    showDummyLinks: true,
  },
  dev: {
    uaiApi: 'https://uai-ppg.vsaas.na1.verimatrixsandboxcloud.net/uai/v1.0/',
    ssiApi: 'https://ssi-ppg.vsaas.na1.verimatrixsandboxcloud.net/ssi/v1.0/',
    smiApi: 'https://smi-ppg.vsaas.na1.verimatrixsandboxcloud.net/smi/v1.0/',
    lookerProxyApi: 'https://d5r2e7pe1d.execute-api.us-east-1.amazonaws.com/prod/v1.0',
    featureMyProfile: true,
    featrueAuditViewer: true,
    featureUserManagmentProfiles: true,
    featureUserManagmentProfilesEdit: true,
    featureUserManagementProducts: true,
    featureVcascloudDevices: true,
    featureVcascloudContent: true,
    featureVcascloudEntitlements: true,
    showDummyLinks: true,
  },
  sandbox: {
    uaiApi: 'https://mh4qqgx3t5.execute-api.us-east-1.amazonaws.com/prod/uai/v1.0/',
    ssiApi: 'https://6nl4h8fmp1.execute-api.us-east-1.amazonaws.com/prod/ssi/v1.0/',
    smiApi: '',
    lookerProxyApi: 'https://d5r2e7pe1d.execute-api.us-east-1.amazonaws.com/prod/v1.0',
    featureMyProfile: true,
    featrueAuditViewer: true,
    featureUserManagmentProfiles: true,
    featureUserManagmentProfilesEdit: true,
    featureUserManagementProducts: true,
    featureVcascloudDevices: true,
    featureVcascloudContent: true,
    featureVcascloudEntitlements: true,
    showDummyLinks: true,
  }
}

const config = configs[environment]

// config object properties
export const UAI_API = 'uaiApi'
export const SSI_API = 'ssiApi'
export const SMI_API = 'smiApi'
export const LOOKER_PROXY_API = 'lookerProxyApi'
export const FEATURE_MY_PROFILE = 'featureMyProfile'
export const FEATURE_AUDIT_VIEWER = 'featrueAuditViewer'
export const FEATURE_USER_MANAGEMENT_PROFILES = 'featureUserManagmentProfiles'
export const FEATURE_USER_MANAGEMENT_PROFILES_EDIT = 'featureUserManagmentProfilesEdit'
export const FETAURE_USER_MANAGEMENT_PRODUCTS = 'featureUserManagementProducts'
export const FEATURE_VCASCLOUD_DEVICES = 'featureVcascloudDevices'
export const FEATURE_VCASCLOUD_CONTENT = 'featureVcascloudContent'
export const FEATURE_VCASCLOUD_ENTITLEMENTS = 'featureVcascloudEntitlements'
export const SHOW_DUMMY_LINKS = 'showDummyLinks'

export const AREYOUTHERE_TIMER = 15 * 60 * 1000 // In miliseconds
export const LOGOUT_TIMER = 1 * 60 * 1000 // Will be displayed X miliseconds after AREYOUTHERE_TIMER
export const VERSION_CHECKER_TTL = 1000 * 60 * 5

if (process.env.REACT_APP_UAI_API) config[UAI_API] = process.env.REACT_APP_UAI_API
if (process.env.REACT_APP_SSI_API) config[SSI_API] = process.env.REACT_APP_SSI_API
if (process.env.REACT_APP_SMI_API) config[SMI_API] = process.env.REACT_APP_SMI_API
if (process.env.REACT_APP_LOOKER_PROXY_API) config[LOOKER_PROXY_API] = process.env.REACT_APP_LOOKER_PROXY_API
if (process.env.REACT_APP_FEATURE_MY_PROFILE) config[FEATURE_MY_PROFILE] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_MY_PROFILE)
if (process.env.REACT_APP_FEATURE_AUDIT_VIEWER) config[FEATURE_AUDIT_VIEWER] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_AUDIT_VIEWER)
if (process.env.REACT_APP_FEATURE_USER_MANAGEMENT_PROFILES) config[FEATURE_USER_MANAGEMENT_PROFILES] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_USER_MANAGEMENT_PROFILES)
if (process.env.REACT_APP_FEATURE_USER_MANAGEMENT_PROFILES_EDIT) config[FEATURE_USER_MANAGEMENT_PROFILES_EDIT] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_USER_MANAGEMENT_PROFILES_EDIT)
if (process.env.REACT_APP_FETAURE_USER_MANAGEMENT_PRODUCTS) config[FETAURE_USER_MANAGEMENT_PRODUCTS] = evaluateEnvFlag(process.env.REACT_APP_FETAURE_USER_MANAGEMENT_PRODUCTS)
if (process.env.REACT_APP_FEATURE_VCASCLOUD_DEVICES) config[FEATURE_VCASCLOUD_DEVICES] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_VCASCLOUD_DEVICES)
if (process.env.REACT_APP_FEATURE_VCASCLOUD_CONTENT) config[FEATURE_VCASCLOUD_CONTENT] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_VCASCLOUD_CONTENT)
if (process.env.REACT_APP_FEATURE_VCASCLOUD_ENTITLEMENTS) config[FEATURE_VCASCLOUD_ENTITLEMENTS] = evaluateEnvFlag(process.env.REACT_APP_FEATURE_VCASCLOUD_ENTITLEMENTS)
if (process.env.REACT_APP_SHOW_DUMMY_LINKS) config[SHOW_DUMMY_LINKS] = evaluateEnvFlag(process.env.REACT_APP_SHOW_DUMMY_LINKS)

if (environment !== 'prod') {
  // eslint-disable-next-line
  console.log('Environment:', environment)
  // eslint-disable-next-line
  console.log('Config:', config)
}

export default config
